import styled from 'styled-components';

export const BuyingOfferMultiStepFormWrapper = styled.div`
`;

export const BuyingOfferMultiStepFormContent = styled.div`
`;